import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { API_CONFIG } from '@core/config/api.config';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (API_CONFIG.useMockAuth) {
    if (auth.isLoggedIn()) {
      return true;
    }
    return router.createUrlTree(['/login']);
  }

  if (!auth.getToken()) {
    return router.createUrlTree(['/login']);
  }

  // Sesión en storage: refresca token y perfil al entrar a rutas protegidas
  const ok = await auth.hydrateSession();
  if (ok) {
    return true;
  }

  return router.createUrlTree(['/login']);
};
